import React from "react";
// TODO: change with https://www.satchel.style/normalize
import CssLayer from "./CssLayer";

const CssBase = () => <CssLayer type="base" />;

export default CssBase;
